import {
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  TooltipTrigger,
  TooltipContent,
  DropdownMenu,
  Typography,
  ColumnDef,
  Tooltip,
  Button,
} from '@ui/components';
import { MenuVertical } from '@ui/components/icons';
import { HasPermission } from '@shared/components';
import { TFunction } from 'i18next';

export function actionColumn<T>(
  t: TFunction,
  onStopParking?: (parkingId: string) => void,
): ColumnDef<T[]> {
  return {
    id: 'actions',
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <HasPermission permissionFeature="PARKINGS_STOP_PARKING" permissionType="WRITE">
            <DropdownMenu>
              <Tooltip>
                <TooltipTrigger tabIndex={-1} asChild>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost">
                      <MenuVertical />
                    </Button>
                  </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent className="w-auto">
                  <Typography variant="labelXSmallBook">
                    {t('PARKING_SPOTS.TABLE_MORE_ACTIONS')}
                  </Typography>
                </TooltipContent>
              </Tooltip>
              <DropdownMenuContent className="w-56">
                <DropdownMenuItem onClick={() => onStopParking?.(row.id)}>
                  {t('PARKING_SPOTS.TABLE_STOP_PARKING')}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </HasPermission>
        </div>
      );
    },
  };
}
